export default __webpack_public_path__ + "static/ProValue_6@mob-528f77d4c354457f8f59be22f110eeb1.png";